import { runtime } from './runtime'

/** @public */
export function hardResetEditor() {
	runtime.hardReset()
}
